import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Row, Col, Button, Card, CardBody, CardHeader, Collapse } from 'reactstrap';
import { FaChevronUp, FaChevronDown} from 'react-icons/fa';
import toast, { Toaster } from 'react-hot-toast';
import uuid from 'react-uuid'; import { apiGet, apiPost } from "../Utilities/Hooks/apiWrapper";

const PagebyPagebreakdown = () => {
    const [farmId, setFarmId] = useState(localStorage.getItem("defaultFarmId"));
    const [loading, setLoading] = useState(true);
    const [pagebyPagebreakdown, setPagebyPagebreakdown] = useState({ summaryList: [] });
    const [isOpen, setIsOpen] = useState(false);
    const [isIconUp, setIsIconUp] = useState(false);

    const toggle = () => {
        setIsOpen(!isOpen)
        setIsIconUp(!isIconUp)
    };

    useEffect(() => {
        setLoading(true);
        OnPageload();
    }, [])

    const OnPageload = async (e) => {
        try {
            const response = await apiGet(
                '/api/summary/GetPagebyPageDetails/', {
                params: {
                    farmId: farmId
                }
            }
            );
            setPagebyPagebreakdown({
                ...pagebyPagebreakdown, summaryList: response.data
            });
            setLoading(false);
        } catch (err) {
            setLoading(false);
            console.log(err);
        }
    }

    const exportPagebyPageSummary = async (e,type) => {
        e.stopPropagation();
        e.preventDefault();
        const response = handlePagebyPageSummaryReport(e, type);
        toast.promise(response, {
            loading: 'Generating report...',
            success: 'Report generated!',
            error: 'Error when generating report',
        });
    }

    const handlePagebyPageSummaryReport = async (e, type) => {
        const response = await apiGet(
            '/api/Summary/GenerateReportPagebyPageSummary/', {
            params: { farmId: farmId,type : type }
        })

        if (response.data.status) {
            var buffer = base64ToArrayBuffer(response.data.content)
            if (type == "Pdf") {
                var file = new Blob([buffer], { type: "application/pdf" })
                var link = document.createElement('a')
                link.href = window.URL.createObjectURL(file)
                link.download = "PagebyPageSummary.pdf";
            }
            else {
                var file = new Blob([buffer], { type: "application/vnd.ms-excel" })
                var link = document.createElement('a')
                link.href = window.URL.createObjectURL(file)
                link.download = "PagebyPageSummary.xlsx";
            }
            document.body.appendChild(link)
            link.click()
        }

    }

    const base64ToArrayBuffer = (data) => {
        var binaryString = window.atob(data);
        var binaryLen = binaryString.length;
        var bytes = new Uint8Array(binaryLen);
        for (var i = 0; i < binaryLen; i++) {
            var ascii = binaryString.charCodeAt(i);
            bytes[i] = ascii;
        }
        return bytes;
    }

    return (
        <Card className="my-4">
            <CardHeader className="item-header item_click" onClick={toggle}>
                <Row>
                    <Col sm="11"><h6>My FWRMP Page by Page Summary
                        {/*<Button style={{ float: "right", background: "none", border: "none" }} onClick={(e) => exportPagebyPageSummary(e,'Excel')} value="Export" placeholder="">*/}
                        {/*    <img src="/images/Excel_icon.png" className="card_icon" ></img>*/}
                        {/*</Button>*/}
                        {/*<Button style={{ float: "right", background: "none", border: "none", marginRight: "-20px" }} onClick={(e) => exportPagebyPageSummary(e,'Pdf')} value="Export" placeholder="">*/}
                        {/*    <img src="/images/PDF_icon.png" className="card_icon" ></img>*/}
                        {/*</Button>*/}
                    </h6></Col>
                    <Col sm="1" className="toggleoutline" style={{ marginLeft: "auto", marginRight: "20px" }}>{isIconUp ? <FaChevronUp /> : <FaChevronDown />}</Col>
                </Row>
            </CardHeader>
            <Collapse isOpen={isOpen}>
                <CardBody >
                    <Row>
                        <Col>
                            <table id="tblMyFWFPList" className="table borderless table-striped border-top-bottom">
                                <thead className="textAlignCenter">
                                    <tr>
                                        <th rowSpan="2">Page</th>
                                        <th rowSpan="2">Items</th>
                                        <th colSpan="2">Actions</th>
                                    </tr>
                                    <tr>
                                        <th>Improvement</th>
                                        <th>Management</th>
                                    </tr>
                                </thead>
                                <tbody className="myFWFPList textAlignCenter" id="myFWFPList">
                                    {pagebyPagebreakdown.summaryList.map(summary =>

                                        <tr key={uuid()}>
                                            <td style={{ textAlign:"left" }}>{summary.page}</td>
                                            <td>{summary.itemCount == 0 ? "" : summary.itemCount}</td>
                                            <td>{summary.improvementActionCount == 0 ? "" : summary.improvementActionCount}</td>
                                            <td>{summary.ongoingActionCount == 0 ? "" : summary.ongoingActionCount}</td>
                                        </tr>
                                    )
                                    }
                                </tbody>
                            </table>
                        </Col>
                    </Row>

                </CardBody>
            </Collapse>
        </Card>
    )
}
export default PagebyPagebreakdown

